import { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";

import { ReactComponent as DownloadIcon } from "../../images/download.svg";
import { CSVLink } from "react-csv";
import { API_BASE } from "core/Constants";
import Modal from "./Modal";

const Exporter = props => {
  const [progress, setProgress] = useState(false);
  const [downloadCSV, setDownloadCSV] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const csvLinkRef = useRef(null);

  let disabled = true;
  if (props.data && props.data.length) {
    disabled = false;
  }

  let buttonProps = {};
  if (disabled) {
    buttonProps.className = "greyed-svg";
  }

  const downloadExcel = async () => {
    if (props.fileID) {
      setProgress(false);
      if(props.selData != 1){
      let url = `${API_BASE}/report/download/excel/${window.btoa(
        props.fileID
      )}`;
      window.open(url, "_blank");
      }else{
        if (!props.data || props.data.length === 0) {
    alert("No data available");
    return;
  }

  // If you want custom headers mapping
  const formattedData = props.data.map(row => {
    let obj = {};
    props.headers.forEach(header => {
      obj[header.label] = row[header.key];
    });
    return obj;
  });

  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  XLSX.writeFile(workbook, props.filename || "data.xlsx");
      }
    }
  };

  const downloadChannelProductPDF = async () => {
    if (props.fileID && props.clientID) {
      setProgress(false);
      let url ='';
      console.log('chk selected',props.selectedPDF);
      if(props.selectedPDF.length > 0){
       url = `${API_BASE}/report/download/pdf/channel-product/${
        props.clientID
      }/${window.btoa(props.fileID)}/${props.icaFlag}/${props.selectedPDF}`;
    }else{
        url = `${API_BASE}/report/download/pdf/channel-product/${
        props.clientID
      }/${window.btoa(props.fileID)}/${props.icaFlag}`;
    }
      window.open(url, "_blank");
    }
  };

  const downloadChannelProductDurationPDF = async () => {
    if (props.fileID && props.clientID) {
      setProgress(false);
      let url = `${API_BASE}/report/download/pdf/channel-product-duration/${
        props.clientID
      }/${window.btoa(props.fileID)}/${props.selectedPDF}`;
      window.open(url, "_blank");
    }
  };

  const download = () => {
    if (downloadCSV) {
      return;
    }

    if (disabled) {
      return;
    }

    setProgress(true);

    if (props.format === "csv") {
      setDownloadCSV(true);
    }

    if (props.format === "xlsx") {
      downloadExcel();
    }

    if (props.format === "pdf") {

      if(props.icaFlag==false){
      setShowModal(true);
      setProgress(false);
      }else{
 downloadChannelProductPDF();
      }
      //setProgress(false);
    }
  };

  const downloadCompleted = () => {
    setDownloadCSV(false);
    setProgress(false);
  };

  useEffect(() => {
    if (downloadCSV) {
      if (csvLinkRef && csvLinkRef.current) {
        csvLinkRef.current.link.click();
        downloadCompleted();
      }
    }
  }, [downloadCSV]);

  const csvComp = downloadCSV ? (
    <CSVLink
      ref={csvLinkRef}
      data={props.data}
      headers={props.headers}
      filename={props.filename}
      style={{ display: "none" }}
      target=""
    />
  ) : (
    <></>
  );

  return (
    <>
      {showModal && (
        <Modal
          onClose={() => {
            setShowModal(false);
          }}
        >
          <div className="flex">
            <div className="row">
              <h2>Select PDF Report</h2>
            </div>
          </div>
          <div
            className="flex mtop"
            style={{ minWidth: "50vw", maxHeight: "50vh" }}
          >
            <button
              onClick={() => {
                downloadChannelProductPDF();
                setShowModal(false);
              }}
            >
              Channel Product
            </button>
            <button
              onClick={() => {
                downloadChannelProductDurationPDF();
                setShowModal(false);
              }}
            >
              Channel Product Duration
            </button>
          </div>
        </Modal>
      )}
      <div
        className="el icon exporter"
        onClick={() => {
          download();
        }}
      >
        {csvComp}
        {progress ? (
          <div className="loader">
            <div className="lds-hourglass"></div>
          </div>
        ) : (
          <DownloadIcon {...buttonProps} />
        )}
      </div>
    </>
  );
};

export default Exporter;
